const mediaWallTriggerOnClick = (target) => {
  const mediaWallEl = document.getElementById('js-media-wall')

  if (target) {
    target.addEventListener('click', (ev) => {
      ev.preventDefault()
      mediaWallEl.classList.toggle('open')
    })
  } else {
    console.warn('Media Wall Trigger On Click: No target given')
  }
}

const initMediaWall = () => {
  const mediaWallTriggerEl = document.querySelectorAll('.js-media-wall-button')
  if (mediaWallTriggerEl) {
    Array.from(mediaWallTriggerEl, target => mediaWallTriggerOnClick(target))
  }
}

export { initMediaWall }